import { z } from "zod"
import { defineOperationContext } from "../define"
import type { MenuDetectMetadataInput } from "../schemas/menu-detect-metadata"

export const menuDetectMetadataContextSchema = z.object({
	flowId: z.string().uuid(),
	menuId: z.string().uuid(),
	/** Route key of the enriched menu, when the caller knew it. */
	menuSlug: z.string().min(1).max(200).optional(),
	productCount: z.number().int().nonnegative(),
})

export type MenuDetectMetadataContext = z.infer<
	typeof menuDetectMetadataContextSchema
>

export const menuDetectMetadataContextSpec = defineOperationContext<
	MenuDetectMetadataInput,
	MenuDetectMetadataContext
>({
	version: 1,
	schema: menuDetectMetadataContextSchema,
	fromInput: (input) => ({
		flowId: input.flowId,
		menuId: input.menuId,
		menuSlug: input.menuSlug,
		productCount: input.products.length,
	}),
})
